import React from "react";
import "../../../css/Tramites/manipulador-alimentos.css";

const manualTeoricoUrl =
  "https://ciudaddeoliva.gov.ar//file/pdf/web-oliva/manuales/manual-alimentos-teorico.pdf";
  
const manualDeliveryUrl =
  "https://ciudaddeoliva.gov.ar//file/pdf/web-oliva/manuales/manual-alimentos-delivery.pdf";
  
const manualTransportistaUrl =
  "https://ciudaddeoliva.gov.ar//file/pdf/web-oliva/manuales/manual-alimentos-transportista.pdf";

const videos = [
  "https://www.youtube.com/watch?v=qjNaJ969Akc",
  "https://www.youtube.com/watch?v=PBunsc-d79E",
  "https://www.youtube.com/watch?v=zeJpyfAa5dE",
  "https://www.youtube.com/watch?v=BLKwhlL6p7w",
  "https://www.youtube.com/watch?v=OWNwknAIL_Q",
];

function getYoutubeId(url) {
  const match = url.match(/(?:v=|\.be\/)([a-zA-Z0-9_-]{11})/);
  return match ? match[1] : "";
}

const ManipuladorAlimentos = () => (
  <div className="manipulador-full-bg">
    <div className="manipulador-container">
      <h1>Carnet de Manipulador de Alimentos</h1>
      <section className="manipulador-section">
        <h2>¿Qué es el Carnet Manipulador de Alimentos?</h2>
        <p>
          El Carnet de Manipulador de Alimentos es exigido por el Código
          Alimentario Argentino (CAA) a toda persona que realice actividades por
          la cual esté o pudiera estar en contacto con alimentos, en
          establecimientos donde se elaboren, fraccionen, almacenen,
          transporten, comercialicen y/o enajenen alimentos, o sus materias
          primas.
        </p>
        <p>
          Es válido en todo el territorio argentino y habilita a las personas a
          desarrollar tareas de manipulación de alimentos.
        </p>
        <p>
          Desde el 18 de agosto del 2021 toda persona que realice tareas de
          manipulación de alimentos debe contar con carnet de manipulador.
        </p>
        <p>
          Para su obtención se debe realizar el curso de Manipulación Segura de
          Alimentos y rendir un examen final. Su vigencia es de tres años a
          partir de su emisión y deberá ser renovado una vez que finalice el
          periodo de vigencia.
        </p>
        <p>
          A diferencia de la antigua libreta sanitaria, el carnet de manipulador
          como política pública pone el foco en la persona y su capacitación,
          entendiendo a la educación como la principal estrategia para tomar
          conciencia y modificar los hábitos del manipulador al momento de la
          elaboración de alimentos inocuos y de acuerdo a los requisitos
          regulatorios vigentes.
        </p>
        <div className="manipulador-botones" style={{ margin: "24px 0" }}>
          <a
            href={manualTeoricoUrl}
            className="manipulador-btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            Descargar Manual Teórico
          </a>
		  <a
            href={manualDeliveryUrl}
            className="manipulador-btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            Descargar Manual para Delivery
          </a>
		  <a
            href={manualTransportistaUrl}
            className="manipulador-btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            Descargar Manual para Transportista
          </a>		

        </div>
        <h3 style={{ marginTop: 24 }}>Videos útiles para el curso</h3>
        <div className="manipulador-videos">
          {videos.map((url, i) => {
            const id = getYoutubeId(url);
            return (
              <div key={id} className="manipulador-video-embed">
                <iframe
                  width="100%"
                  height="220"
                  src={`https://www.youtube.com/embed/${id}`}
                  title={`Video ${i + 1}`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            );
          })}
        </div>
        <div style={{ marginTop: 32 }}>
          <b>Para inscripciones</b> comunicarse al teléfono{" "}
          <a href="tel:03532410289">03532-410289 int. 35</a> o vía e-mail a{" "}
          <a href="mailto:dabigmunoliva@gmail.com">dabigmunoliva@gmail.com</a>
        </div>
      </section>
    </div>
  </div>
);

export default ManipuladorAlimentos;
